import script from "./PageCover.vue?vue&type=script&setup=true&lang=js"
export * from "./PageCover.vue?vue&type=script&setup=true&lang=js"

import "./PageCover.vue?vue&type=style&index=0&id=01d385ec&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-01d385ec"]])

export default __exports__